/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarListDtoFromJSON, CarListDtoToJSON, CustomerDtoFromJSON, CustomerDtoToJSON, ProtocolDtoFromJSON, ProtocolDtoToJSON, } from './';
export function ReservationDetailDtoFromJSON(json) {
    return ReservationDetailDtoFromJSONTyped(json, false);
}
export function ReservationDetailDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'car': !exists(json, 'car') ? undefined : CarListDtoFromJSON(json['car']),
        'customer': !exists(json, 'customer') ? undefined : CustomerDtoFromJSON(json['customer']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'begins': !exists(json, 'begins') ? undefined : (new Date(json['begins'])),
        'ends': !exists(json, 'ends') ? undefined : (new Date(json['ends'])),
        'protocolDeliver': !exists(json, 'protocolDeliver') ? undefined : ProtocolDtoFromJSON(json['protocolDeliver']),
        'protocolReturn': !exists(json, 'protocolReturn') ? undefined : ProtocolDtoFromJSON(json['protocolReturn']),
    };
}
export function ReservationDetailDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'car': CarListDtoToJSON(value.car),
        'customer': CustomerDtoToJSON(value.customer),
        'description': value.description,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'createdBy': value.createdBy,
        'createdById': value.createdById,
        'begins': value.begins === undefined ? undefined : (value.begins.toISOString()),
        'ends': value.ends === undefined ? undefined : (value.ends.toISOString()),
        'protocolDeliver': ProtocolDtoToJSON(value.protocolDeliver),
        'protocolReturn': ProtocolDtoToJSON(value.protocolReturn),
    };
}
